import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import course_img from "../../assets/img/courseImg.png";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import { ModalHeader } from "../../common/modalHeader";
import { getAllCompanypRODUCTS, getCompany, getCompanypRODUCTS } from "../WhiteLabels/whitelabelApi";
import AllMediaModelApp from "../Jobs/AllMediaShow";
export default function CompnayInforamtion({
  open,
  setOpen,
  modalData,
  viewType,
}) {
  const [companyData, setCompanyData] = useState();
  const [hide, setHide] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const payload = {
      billerId: modalData?.billerId,
    };

    if (open && viewType === "company") {
      // callCompanyAPI(modalData?.id);
      getCompany(payload, (res) => {
        const obj = res?.data?.data?.list?.[0];
        // if (!obj) {
        //   // NO DATA → RESET FORM FOR ADD
        //   setFranchise({ ...struct, billerId });
        //   setSelectedImages([]);
        //   return;
        // }

        // setSelectedImages([]);
        setCompanyData(obj);

        // console.log(obj);
      });
    }

    if (open && viewType === "product") {
      // callProductAPI(modalData?.id);
      getAllCompanypRODUCTS(payload, (data) => {
        // console.log("Courses- ", data.data.data.list);
        setCompanyData(data.data.data.list);
      });
    }
  }, [open, viewType]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const labelStyle = {
    fontWeight: 500,
    color: "#000000",
    fontSize: { xs: "12px", sm: "13px", md: "16px" },
    whiteSpace: "nowrap",
  };
  const labelStyle1 = {
    display: "flex",
    justifyContent: "space-between",
  };
  const valueStyle = {
    fontWeight: 400,
    color: "#030505",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            background: "white",
            width: { xs: "95%", sm: "60%", md: "45%", lg: "35%" },
            overflowY: "auto",
            height: { xs: "80vh", sm: "75vh", md: "75vh", lg: "70vh" },
            position: "absolute",
            borderRadius: "10px",
            left: { xs: "2%", sm: "25%", md: "35%", lg: "30%" },
            top: "12%",
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "auto",
              padding: "16px 24px",
              fontFamily: "'Montserrat', sans-serif",
              borderRadius: "10px",
              fontSize: { xs: "12px", sm: "13px", md: "20px" },
              fontWeight: 600,
            }}
          >
            {viewType === "company"
              ? "Company Details"
              : viewType === "product"
              ? "Product Details"
              : ""}
            <CloseIcon
              sx={{ float: "left", cursor: "pointer" }}
              onClick={() => onClose(false)}
            />
          </DialogTitle>
          <Divider sx={{ borderBottom: "1px solid #01008B" }} />
          {viewType === "company" && (
            <DialogContent sx={{ p: 2, px: 4 }}>
              <Grid container>
                {/* intro */}

                <Grid container>
                  <Grid item xs={9}>
                    <Typography
                      sx={{
                        fontSize: { xs: "16px", sm: "18px", md: "24px" },
                        fontWeight: 600,
                      }}
                    >
                      {companyData?.companyName || "-"}
                    </Typography>
                    <Box
                      sx={{
                        mt: 1,
                        border: "2px solid #01008B",
                        borderRadius: "10px",
                        px: 2,
                        py: 0.5,
                        width: "fit-content",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setHide(true);
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "14px", md: "16px" },

                          fontWeight: 600,
                          color: "#01008B",
                        }}
                      >
                        Social Media Links
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    alignItems="center"
                    sx={{ display: "flex", justifyContent: "end" }}
                  >
                    <Box
                      component="img"
                      src={companyData?.logo}
                      // alt="Job"
                      sx={{
                        width: { xs: "100%", sm: 80, md: 80, lg: 100 },
                        height: { xs: 180, sm: 90, md: 80, lg: 100 },
                        maxHeight: 100,
                        maxWidth: 100,
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  {/* address*/}
                  <Grid
                    sx={{ borderBottom: "1px solid #01008B", py: 2 }}
                    item
                    xs={12}
                    md={12}
                  >
                    <Box
                      sx={{
                        ...labelStyle1,
                      }}
                    >
                      <Typography sx={labelStyle}> Address:</Typography>
                      <Typography sx={valueStyle}>
                        {companyData?.briefAddress}{" "}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        ...labelStyle1,
                      }}
                    >
                      <Typography sx={labelStyle}> State :</Typography>
                      <Typography sx={valueStyle}>
                        {" "}
                        {companyData?.state}{" "}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        ...labelStyle1,
                      }}
                    >
                      <Typography sx={labelStyle}> District :</Typography>
                      <Typography sx={valueStyle}>
                        {" "}
                        {companyData?.district}{" "}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        ...labelStyle1,
                      }}
                    >
                      <Typography sx={labelStyle}> City :</Typography>
                      <Typography sx={valueStyle}>
                        {" "}
                        {companyData?.city}{" "}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        ...labelStyle1,
                      }}
                    >
                      <Typography sx={labelStyle}> Pincode :</Typography>
                      <Typography sx={valueStyle}>
                        {" "}
                        {companyData?.pincode}{" "}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography sx={labelStyle}>Email Id :</Typography>
                    <Typography sx={valueStyle}>
                      {companyData?.emailId1}{" "}
                    </Typography>
                    <Typography sx={labelStyle}>Email Id :</Typography>
                    <Typography sx={valueStyle}>
                      {companyData?.emailId2}{" "}
                    </Typography>
                    <Typography sx={labelStyle}>Mobile No. :</Typography>
                    <Typography sx={{ ...valueStyle, display: "flex" }}>
                      {companyData?.mobileNumber1}{" "}
                    </Typography>
                    <Typography sx={labelStyle}>Mobile No. :</Typography>
                    <Typography sx={{ ...valueStyle, display: "flex" }}>
                      {companyData?.mobileNumber2}{" "}
                    </Typography>
                    <Typography sx={labelStyle}>Whatsapp No. :</Typography>
                    <Typography sx={{ ...valueStyle, display: "flex" }}>
                      {companyData?.whatsappNumber}{" "}
                      {modalData?.whatsappNumber && (
                        <IconButton
                          size="small"
                          sx={{ p: 0, ml: 1 }}
                          onClick={() =>
                            window.open(
                              `https://web.whatsapp.com/send?phone=${modalData?.userMobile}`,
                              "_blank",
                            )
                          }
                        >
                          <WhatsAppIcon
                            sx={{
                              color: "white",
                              fontSize: 20,
                              borderRadius: "50%",
                              backgroundColor: "#25D366",
                              p: "3px",
                            }}
                          />
                        </IconButton>
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
          )}

          {viewType === "product" && (
            <DialogContent sx={{ p: 2, px: 4 }}>
              <Grid container>
                {/* intro */}

                <Grid container>
                  <Grid
                    item
                    xs={12}
                    alignItems="center"
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Box
                      component="img"
                      src={modalData?.productImage}
                      // alt="Job"
                      sx={{
                        width: { xs: "100%", sm: 80, md: 100, lg: 200 },
                        height: { xs: 180, sm: 90, md: 100, lg: 200 },
                        maxHeight: 200,
                        maxWidth: 200,
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  {/* address*/}
                  <Grid
                    sx={{ borderBottom: "1px solid #01008B", py: 2 }}
                    item
                    xs={12}
                    md={12}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "18px", md: "24px" },
                          fontWeight: 600,
                        }}
                      >
                        {" "}
                        {modalData?.productName || "-"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        ...labelStyle1,
                      }}
                    >
                      <Typography sx={labelStyle}> Product Id :</Typography>
                      <Typography sx={valueStyle}>
                        {" "}
                        {modalData?.productId || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography sx={labelStyle}>Discription :</Typography>
                    <Typography sx={valueStyle}>
                      {modalData?.productDescription || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
          )}
        </Box>
      </Modal>
      <AllMediaModelApp
        open={hide}
        setOpen={setHide}
        modelData={{
          google: "",
          website: "",
          instagram: "",
          facebook: "",
          youTube: "",
          pinterest: "",
          twitter: "",
          linkedIn: "",
          ...companyData,
        }}
        // setModalData={setMyBussinessData}
      />
    </>
  );
}
